import classNames from 'classnames';
import React from 'react';
import { IconSpinner } from './QuirkIcons';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
interface ContentPreloaderProps {
	message: string;
}

export const ContentPreloader: React.FC<ContentPreloaderProps> = ({ message }) => {
	return (
		<div className={classNames(sharedStyles.noResults, 'center-align')}>
			<IconSpinner />

			<div className="space20" />
			{<h5>{message}</h5>}
		</div>
	);
};
